<template>
  <div class="page-case-details h-100" v-if="pavement">
    <div class="case-item d-block">
      <div
        class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center mb-3 mb-sm-0"
      >
        <div class="flex-shrink-0">
          <div
            class="case-image bg-light"
            v-if="Helper.getCaseImage(pavement.media)"
          >
            <img
              :src="Helper.getCaseImage(pavement.media)"
              class="clickable"
              @click="openMediaPreview(pavement.media)"
            />
          </div>
        </div>
        <div class="flex-grow-1 ms-sm-3">
          <div class="d-flex">
            <p class="fw-bold mb-0 text-secondary me-3">
              <span># {{ pavement.serialNo }} </span>
            </p>
            <p
              class="fw-bold mb-0"
              :class="
                pavement.progress == 100
                  ? 'text-success'
                  : pavement.progress > 50 && pavement.progress <= 99
                  ? 'text-primary'
                  : pavement.progress < 50
                  ? 'text-warning'
                  : 'text-muted'
              "
            >
              <span>Progress {{ pavement.progress }}% </span>
            </p>
          </div>
          <p class="fw-bold mb-0">
            {{ pavement.caption }}
          </p>
          <div class="pt-2 pb-3">
            <span class="badge bg-light text-dark px-3">Tampalan PBT</span>
          </div>
          <p class="small mb-0">
            Start:
            {{
              Helper.formatDate(pavement.start_date, false)
                ? Helper.formatDate(pavement.start_date, false)
                : "Date not set"
            }}, Completed:
            {{
              Helper.formatDate(pavement.end_date, false)
                ? Helper.formatDate(pavement.end_date, false)
                : "Date not set"
            }}
          </p>
          <p
            class="small mb-0 fs-6 fw-bold"
            v-html="Helper.pavementRoadNames(pavement)"
          ></p>
          <p
            class="small mb-0 fs-6 fw-bold"
            v-if="pavement.lat && pavement.lng"
          >
            {{ Helper.formatCoordinate([pavement.lat, pavement.lng]) }}
          </p>
          <div class="mt-2">
            <button
              class="btn btn-dark me-2"
              :disabled="!pavement.ortho_before"
              @click="openTab(pavement.ortho_before)"
            >
              <p class="m-0"><i class="far fa-map me-2"></i>before</p>
            </button>
            <button
              class="btn btn-dark"
              :disabled="!pavement.ortho_after"
              @click="openTab(pavement.ortho_after)"
            >
              <p class="m-0"><i class="far fa-map me-2"></i>after</p>
            </button>
          </div>
        </div>

        <div
          class="flex-shrink-0 flex-grow-0 align-self-start ms-sm-3 mt-3 mt-sm-0 ms-auto"
        >
          <button class="btn btn-sm btn-info me-2" @click="editCase()">
            <i class="fas fa-pen-to-square me-2" />
            Edit Details
          </button>
          <button class="btn btn-sm btn-danger" @click="deleteCase">
            <i class="fas fa-trash me-2" />
            Delete AK
          </button>
        </div>
      </div>
    </div>
    <div class="overflow-hidden w-100 py-3">
      <button
        class="btn btn-sm rounded-3 me-3 my-1"
        :class="
          currentTab == tab.name
            ? 'btn-primary text-white'
            : 'fw-bold text-light'
        "
        v-for="tab in computedNavTabs"
        :key="`navTab-${tab.name}`"
        @click="currentTab = tab.name"
      >
        <!-- Enable all tabs -->
        <!-- :disabled="
          !tab.enabledWhenStatus.some((e) => pavement.caseStatus.includes(e))
        " -->
        {{ tab.title }}
        <!-- <i
          v-if="tabIsCompleted(tab.name)"
          class="fa-solid fa-check-circle ms-2"
          :class="currentTab == tab.name ? 'text-white' : 'text-success'"
        /> -->
      </button>
    </div>
    <div class="dropdown-divider mt-0"></div>

    <component
      v-if="currentTab"
      :is="currentComponentName"
      :component-id="currentComponentId"
      :component-name="currentComponentName"
      :component-title="currentComponentTitle"
      :collection-name="currentComponentCollection"
      :pavement-data="pavement"
      :pavement-id="pavement._id"
      @open-media-preview="openMediaPreview"
      @componentIsCompleted="navigateNextComponent"
    />

    <div v-else class="text-center fst-italic p-3">Component not found</div>

    <media-viewer
      :url="currentMedia"
      :mimeType="currentMediaMimeType"
      v-if="currentMedia"
      @close="currentMedia = null"
    />

    <edit-pavement-case-modal
      :show="showEditCaseModal"
      :pavement="pavement"
      @close="closeEditCaseModal"
    />
  </div>
  <div
    class="case-item justify-content-center text-secondary fst-italic"
    v-else
  >
    Invalid case
  </div>
</template>

<script>
import EditPavementCaseModal from "@/components/EditPavementCaseModal";
import MediaViewer from "@/components/MediaViewer";
import PavementDetails from "@/views/PavementCases/Details";
import PendingBq from "@/views/PavementCases/PendingBq";
import PendingWo from "@/views/PavementCases/PendingWo";
import PendingPqp from "@/views/PavementCases/PendingPqp";
import Subworks from "@/views/PavementCases/Subworks";
import Gallery from "@/views/PavementCases/Gallery";
import PendingUpload from "@/views/PavementCases/PendingUpload";
import Swal from "sweetalert2";

export default {
  components: {
    MediaViewer,
    PavementDetails,
    PendingBq,
    PendingWo,
    PendingPqp,
    Subworks,
    Gallery,
    PendingUpload,
    EditPavementCaseModal,
  },
  data() {
    return {
      showCases: false,
      showEditCaseModal: false,
      pavement: null,
      currentMedia: null,
      currentMediaMimeType: null,
      navTabs: [
        {
          name: "pavement-details",
          title: "1. Details",
          collectionName: "details",
        },
        {
          name: "pending-bq",
          title: "2. BQ",
          collectionName: "bq",
        },
        {
          name: "pending-wo",
          title: "3. Work Order",
          collectionName: "wo",
        },
        {
          name: "pending-pqp",
          title: "4. PQP",
          collectionName: "pqp",
        },
        {
          name: "subworks",
          title: "5. Subworks",
          collectionName: "subworks",
        },
        {
          name: "coring-test",
          title: "6. Coring Test",
          collectionName: "coringTest",
          componentName: "pending-upload",
          componentTitle: "Coring Test",
        },
        {
          name: "jms",
          title: "7. JMS",
          collectionName: "jms",
          componentName: "pending-upload",
          componentTitle: "JMS",
        },
        {
          name: "claim",
          title: "8. Claim",
          collectionName: "claim",
          componentName: "pending-upload",
          componentTitle: "Claim",
        },
        {
          name: "gallery",
          title: "9. Gallery",
          collectionName: "gallery",
          componentName: "gallery",
          componentTitle: "Gallery",
        },
      ],
      currentTab: null,
    };
  },
  computed: {
    computedNavTabs() {
      let _navTabs = JSON.parse(JSON.stringify(this.navTabs));

      return _navTabs;
    },
    currentComponentId() {
      if (!this.pavement) return null;

      const activeTabIndex = this.navTabs.findIndex(
        (tab) => tab.name == this.currentTab
      );

      return this.pavement[this.navTabs[activeTabIndex].collectionName]?._id;
    },
    currentComponentName() {
      if (!this.pavement) return null;

      const activeTab = this.navTabs.find((tab) => tab.name == this.currentTab);

      return activeTab?.componentName || activeTab?.name;
    },
    currentComponentTitle() {
      if (!this.pavement) return null;

      const activeTab = this.navTabs.find((tab) => tab.name == this.currentTab);

      return activeTab?.componentTitle;
    },
    currentComponentCollection() {
      if (!this.pavement) return null;

      const activeTab = this.navTabs.find((tab) => tab.name == this.currentTab);

      return activeTab?.collectionName;
    },
    tabIsCompleted() {
      return (tabName) => {
        const tabObject = this.navTabs.find((tab) => tab.name == tabName);

        if (!tabObject) return false;

        return true;
      };
    },
  },
  methods: {
    deleteCase() {
      Swal.fire({
        icon: "question",
        title: "Delete this AK?",
        html: "This action is not reversible!",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: "Delete",
        confirmButtonColor: "red",
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.Helper.toggleLoadingSpinner(true);

          await this.API.del(`pavement-cases/${this.$route.params.id}`);

          this.Helper.toggleLoadingSpinner(false);

          Swal.fire("AK deleted", "", "success").then(() => {
            // this.closeModal(true);
            this.$router.push({ name: "pavement.all" });
          });
        }
      });
    },
    openTab(url) {
      window.open(url, "_blank");
    },
    closeEditCaseModal(e) {
      this.showEditCaseModal = false;

      if (e) {
        this.getCase();
      }
    },
    editCase() {
      this.showEditCaseModal = true;
    },
    openMediaPreview(media, mimeType) {
      if (!media || media.length == 0) return;

      this.currentMedia =
        typeof media == "object" ? this.Helper.getCaseImage(media) : media;

      this.currentMediaMimeType = mimeType;
    },
    getCase() {
      this.Helper.toggleLoadingSpinner(true);

      return new Promise(async (resolve, reject) => {
        let url = `pavement-cases/${this.$route.params.id}`;

        const [call, error] = await this.Helper.handlePromise(
          this.API.get(url)
        );

        if (error) {
          console.error(error);

          reject(error);
        } else {
          this.pavement = call.data;

          resolve();
        }

        this.Helper.toggleLoadingSpinner(false);
      });
    },
    navigateNextComponent(e) {
      this.getCase();
    },
  },
  mounted() {
    this.currentTab = this.navTabs[0].name;

    this.getCase();
  },
};
</script>